import styled from 'styled-components';

const Thumbnail = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 8px;
`;

export default Thumbnail;
